import MainRoutes from "../../routes/MainRoutes";
import { StyledMain } from "../../styles/Main";

export default function Main() {
	return (
		<StyledMain data-testid="main">
			<MainRoutes />
		</StyledMain>
	);
}
